import { render, staticRenderFns } from "./ConvoCard.vue?vue&type=template&id=458aea76&scoped=true&"
import script from "./ConvoCard.vue?vue&type=script&lang=js&"
export * from "./ConvoCard.vue?vue&type=script&lang=js&"
import style0 from "./ConvoCard.vue?vue&type=style&index=0&id=458aea76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458aea76",
  null
  
)

export default component.exports